import { PDF_ELEMENT_HANDLER_DICTIONARY } from './pdf-types';
import PreCheckerDict from './pre-checker';
import ContentPreChecker from './pre-checker';
import autoTable from 'jspdf-autotable';
import { copyBuilderInstance } from './helpers';

const getTextAlignmentValues = (valign:string, calign:string, YPos:number, XPos:number, height:number, width:number) => {
  let modifiedYPos = 0;
  let modifiedXPos = 0;
  let baseline:"hanging" | "middle" | "top" | "bottom";
  let align:"right" | "center" | "left";
  switch(valign) {
    case "top":
          modifiedYPos = YPos;
          baseline = "top"
          break;
    case "middle":
          modifiedYPos = YPos + (height/ 2);
          baseline = "middle"
      break;
    case "bottom":
          modifiedYPos = YPos + height;
          baseline = "bottom"
      break;
    default:
        modifiedYPos = YPos + (height/ 2);
        baseline = "middle"
        break;

  }

  switch(calign) {
    case "left":
          modifiedXPos = XPos;
          align = 'left'
          break;
    case "center":
          modifiedXPos = XPos + (width/ 2);
          align = 'center'
      break;
    case "right":
          modifiedXPos = XPos + width;
          align = 'right'
      break;
    default:
      modifiedXPos = XPos + (width/ 2);
      align = 'center'
      break;

  }
  return  {
    baseline, modifiedXPos, modifiedYPos, align
  }
}

/**
 *  Content Adder is used to add the content into the page
 */
const ContentAdderDict:PDF_ELEMENT_HANDLER_DICTIONARY = {

  /**
   * Image
   * @param dataObject 
   * @param x 
   * @param y 
   */
    'Image': function(dataObject:any , x:number, y:number)  {
      let {
        preCheckedWidth,
        preCheckedHeight,
      } = ContentPreChecker['Image'].bind(this)(dataObject, x, y);
      this.doc.addImage(dataObject.data, 'png', x, y, preCheckedWidth, preCheckedHeight)   
    },

    /**
     * Text
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'Text':  function(dataObject:any,  x:number, y:number)  {
      //console.log(dataObject)
      let attributes = dataObject.attr;
      let font  = attributes.font || "TrebuchetMS";
      let color = attributes.color || [0, 0, 0];
      let size = attributes.fontSize || 15;
      this.doc.setFont(font);
      this.doc.setFontSize(size);
      this.doc.setTextColor(color[0], color[1], color[2]);
      let options:any =  {
        maxWidth: this.getContainerWidth(),
      };
      if(attributes?.baseline) {
        options['baseline'] = attributes?.baseline;
      }
      let text = dataObject.data;
      this.doc.text(text,x, y, options);
    },

    /**
     * Table: used auto table plugin
     * @param dataObject 
     * @param x 
     * @param y 
     * @returns 
     */
    'Table': function(dataObject:any,  x:number, y:number)  {
        if(dataObject?.data?.type === "AudiogramComparisionTable"){
          let { head, body, chartImageData} = dataObject.data;
          let that  = this;
          let margin = this.getMargin();
          /**
           *  Done by renjith don't know why it's not working, Commenting it for now.
           *  margin['left'] = 0;
           *  margin['rigt'] = 0;
           */
         
          autoTable(this.doc, {
            startY: y,
            head: [head],
            body:body,
            margin:margin,
            theme: 'plain',
            willDrawPage: (data) => {
              if(data.table.startPageNumber){
                if(data.table.startPageNumber != data.pageNumber){
                  that.addHeaderAndFooter();
                }
              }
            },
            didDrawCell: function(data) {
              if (data.section === 'body') {
                const base64Img = chartImageData[data.column.index];
                const cx = (that.getPDFWidth() - base64Img.attr.width * 2) / 3;
                const cellX = data.column.index == 0 ? data.cell.x + cx : data.cell.x + (cx * 0.5);
                that.doc.addImage(base64Img.data, 'JPEG', cellX, data.cell.y + 15, base64Img.attr.width, base64Img.attr.height)
              }
            },
            tableWidth: this.getContainerWidth(),
            styles: {
              font: 'TrebuchetMS',
              fontStyle: 'normal',
              halign: dataObject.attr.halign,
            },
            bodyStyles: {
              halign: 'center'
            },
            columnStyles: {
              ["halign"]: {halign:'center'}      
            }
          });
        } else {   
          let { head, body} = dataObject.data;
          let that  = this;
          let margin = { left : x, ...this.getMargin()};
          /**
           * Things to do tomorrow
           *  1. Accept styles from backend from attributes (using Object.assign)
           *  2. Create a table profile for render different styled tables (Need to do the research).
          */
          
          autoTable(this.doc, {
            startY: y,
            head: [head],
            body:body,
            margin: margin,
            tableWidth: this.getContainerWidth(),
            theme: 'plain',
            willDrawPage: (data) => {
              if(data.table.startPageNumber){
                if(data.table.startPageNumber != data.pageNumber){
                  that.addHeaderAndFooter();
                }
              }
            },
            styles: {
              font: 'TrebuchetMS',
              fontStyle: 'normal',
              halign: "center",
              valign : "middle",
            }
          });
        }
        
        return (this.doc as any).lastAutoTable.finalY - this.nextYCoord;      
    },
    
    /**
     * Spacer: add empty space between content
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'Spacer': function(dataObject:any,  x:number, y:number)  {

    },

    /**
     * Spacer: add empty space between content
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'Line': function(dataObject:any,  x:number, y:number)  {
        let prevLineWidth = this.doc.getLineWidth();
        this.doc.setLineWidth(0.5);
        this.doc.setDrawColor(dataObject.attr.lineColor);
        this.doc.line(x, y, x + this.getContainerWidth(), y, 'S');
        this.doc.setLineWidth(prevLineWidth);
    },

    /**
     * AudiometryContainer
     * @param dataObject 
     */
    'AudiometryContainer': function (dataObject:any, x:number, y:number) {
      const pageWidth = this.getPDFWidth(); 

      const cellWidth = 90; //audiometry card width
      const cellHeight = 50; //audiometry card height
      const lineHeight = 20;
      const cellPadding = 15;
      // scrappy logic fo find the cell width
      let itemCounts = dataObject.data.length;
      let itemPerRow = 0;
      let rowCount = 1;
      let _pW = pageWidth;
      let _iWf = 0;
      while(itemCounts > 0) {
        let width  = 0;
        if(_iWf == 0) {
           width  = cellWidth;
        } else{
          width  = cellWidth +   cellPadding;
        }
     
        if( _pW > width) {
          _pW = _pW - width;
          _iWf++;
        }  else {
           if(!itemPerRow) {
            itemPerRow = _iWf;
           }
           _iWf = 0;
           _pW = pageWidth;
           rowCount++;
        }    
        itemCounts--;
      }

      if(itemPerRow == 0) {
        itemPerRow =  dataObject.data.length
      }


      // find how many items will fit in a single row
      // let itemsWillFitInRow = Math.floor(pageWidth/cellWidth);
      // let numberOfRows = Math.round(dataObject.data.length/itemsWillFitInRow);
      let itemsWillFitInRow = itemPerRow;
      let numberOfRows = rowCount;
     
      var startX = x;
      var startY = y;
  
      this.doc.setFontSize(10);

      let that = this;
  
      function getHexToRgb(hex: any) {
        const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
        return {
          r,
          g,
          b,
        };
      }
      
      function cardWriter(item: { title: any; audiogramDate: any; lineColor: any; }, xAxis: any, yAxis: any) {
        that.doc.setLineWidth(1);
        that.doc.setDrawColor(196, 196, 196);
        that.doc.rect(xAxis, yAxis, cellWidth, cellHeight);
  
        that.doc.text(item.title, xAxis +5, yAxis + 12 );
        that.doc.text(new Date(item.audiogramDate).toLocaleDateString('en-UK'), xAxis +5, yAxis + cellHeight-15);
  
        if(item?.lineColor){
          that.doc.setLineWidth(2);        
          const lc = getHexToRgb(item.lineColor);
          that.doc.setFillColor(lc.r, lc.g, lc.b);  
          that.doc.rect(xAxis, yAxis + cellHeight-8, cellWidth, (lineHeight * 0.2), 'F');        
        }
      }
      let data  = dataObject.data;
      let counter = 0;
     for(let row = 0; row < numberOfRows ; row++) {
        for(let i = 0; i < itemsWillFitInRow; i++) {
          let _d = data[counter];
          if(_d) {
            cardWriter(_d, startX, startY);
            startX = startX + cellWidth + cellPadding
            counter++;
          }         
        }
        startY += cellHeight + this.SPACE_BETWEEN_CONTENT;
        startX = x; 
     }

      return numberOfRows * cellHeight + ((numberOfRows -1 ) * this.SPACE_BETWEEN_CONTENT);
    },

    /**
     * Kennedys Brand Box: Bos with green line in left side.
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'KennedysBrandBox': function(dataObject:any, x:number, y:number) {
      let height = dataObject.dimensions.height;
      let width = dataObject.dimensions.width;
      let prevFontSize = this.doc.getFontSize();
      let prevLineWidth = this.doc.getLineWidth();
      
      let lineHeight = height/3;
      let marginLeft = 15; 
      
      this.doc.setDrawColor(dataObject.attr.borderColor);  
      this.doc.rect(x, y, width, height);

      this.doc.setFontSize(dataObject.attr.headlineFontSize);
      //Place headline  
      this.doc.text(dataObject.data.headline, x + marginLeft,  y +lineHeight, {
        baseline: 'middle'
      })  
      
      this.doc.setFontSize(dataObject.attr.sublineFontSize);
      this.doc.text(dataObject.data.subline, x + marginLeft,  y + (2*lineHeight), {
        baseline: 'middle'
      }) 
     
      // daw the green line
      this.doc.setLineWidth(4);
      this.doc.setDrawColor("#00ab8e");
      this.doc.line(x, y, x, y + height, 'D');
      this.doc.setFontSize(prevFontSize);
      this.doc.setLineWidth(prevLineWidth);
    },


    /**
     * Kennedys Brand Box: Bos with green line in left side.
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'FeaturedTable': function(dataObject:any, x:number, y:number) {
      // For this item we need the following items;
      // Common
      // Space between columns => spaceBetweenColumn 
      // Alignment => align => 'left' | 'right' | 'center'
      // 
      // Supported Cell property :
      // "String" | object
      // object format = { value: "sds", border: arrayOF4 | number, fontSize:  number, valign: ""  }
      
      // Conf
      const spaceBetweenColumn = dataObject.attr.spaceBetweenColumn;
      const globalBorderColor = dataObject.attr.borderColor;
      const globalContentVerticalAlign = dataObject.attr.contentVerticalAlign;
      const globalContentAlign = dataObject.attr.contentAlign;
      const globalFontSize = dataObject.attr.fontSize;
      const prevFontSize = this.doc.getFontSize();
      this.doc.setFontSize(globalFontSize);


      const drawBorder = (
        border: number | number[], 
        startX:number, 
        startY:number, 
        width:number, 
        height:number, 
        borderColor:string
      ) => {
          if(Number.isInteger(border)) {
            border  = (new Array(4)).fill(border);
          }
          
          if(!Array.isArray(border)) {
            return ;
          }

          if(this._DEBUG) {
            console.log("draw border", border, startX, startY, width, height )
          }
          
          // We are following w3 schema ; trbl => top, right, bottom, left
          let startXPos = startX;
          let startYPos = startY;

          this.doc.setDrawColor(borderColor);
          let prevLineWidth = this.doc.getLineWidth();

          // Refactor this code.
          if(border[0] > 0) {
            // Top
            this.doc.setLineWidth(border[0]);
            this.doc.line(startXPos, startYPos, startXPos + width, startYPos, 'S');
          }

          if(border[1]> 0) {
            // Right
            this.doc.setLineWidth(border[1]);
            this.doc.line(startXPos, startYPos, startXPos, startYPos + height, 'S');
          }
          if(border[2]> 0) {
            // Bottom
            this.doc.setLineWidth(border[2]);
            this.doc.line(startXPos, startYPos + height, startXPos + width, startYPos + height, 'S');
          }
          if(border[3]> 0) {
            // Left
            this.doc.setLineWidth(border[3]);
            this.doc.line(startXPos + width, startYPos, startXPos + width, startYPos + height, 'S');
          }
          this.doc.setLineWidth(prevLineWidth);
      }

      const getTextAlignment = function (
         cellAlign:string,
         cellValign:string, 
         XPos:number, 
         YPos:number, 
         width:number, 
         height: number
      ): {
        baseline:"hanging" | "middle" | "top" | "bottom",
        align:"right" | "center" | "left",
        modifiedXPos: number,
        modifiedYPos: number
      } {
        // alignment conf

            // vertical alignment
            // for top : y = startY , baseline = 'hanging'
            // for middle: y = heightOfCell/2,  baseline = 'middle'
            // for bottom: y = heightOfCell, baseline = 'top'

             // vertical alignment
            // for top : y = startY , baseline = 'hanging'
            // for middle: y = heightOfCell/2,  baseline = 'middle'
            // for bottom: y = heightOfCell, baseline = 'top'

            let baseline: "hanging" | "middle" | "top" | "bottom";
            let align:"right" | "center" | "left";
            let modifiedXPos : number, modifiedYPos:number;
            switch(cellValign) {
              case "top":
                    modifiedYPos = YPos;
                    baseline = "top"
                    break;
              case "middle":
                    modifiedYPos = YPos + (height/ 2);
                    baseline = "middle"
                break;
              case "bottom":
                    modifiedYPos = YPos + height;
                    baseline = "bottom"
                break;
              default:
                  modifiedYPos = YPos + (height/ 2);
                  baseline = "middle"
                  break;

            }

            switch(cellAlign) {
              case "left":
                    modifiedXPos = XPos;
                    align = 'left'
                    break;
              case "center":
                    modifiedXPos = XPos + (width/ 2);
                    align = 'center'
                break;
              case "right":
                    modifiedXPos = XPos + width;
                    align = 'right'
                break;
              default:
                modifiedXPos = XPos + (width/ 2);
                align = 'center'
                break;

            }
            return  {
              baseline, modifiedXPos, modifiedYPos, align
            }
          
      }
 
      // Width
      let totalWidth =  dataObject.dimensions.width > this.getContainerWidth() ? this.getContainerWidth() : dataObject.dimensions.width;
     
      // extract width configuration from head
      const widthsFromHeader =  dataObject.data.head.reduce((accumulator:any, cv:any, index:number) => {
        if(cv['width']) {
          accumulator[index] = cv['width'];
        }
        return accumulator;
      }, {});

      let CUSTOM_WIDTH_SETTINGS = false;
      let preOccupiedWidth = 0;
      let preOccupiedCount = 0;
      if(Object.keys(widthsFromHeader).length > 0) {
        CUSTOM_WIDTH_SETTINGS = true;
        preOccupiedCount = Object.keys(widthsFromHeader).length;
        preOccupiedWidth = Object.keys(widthsFromHeader).reduce((width:number, cv)=> {
          if(widthsFromHeader[cv]) {
            width += widthsFromHeader[cv];
          }
          return width;
        }, 0)
      }

      
      let totalColumns = dataObject.data.head.length - preOccupiedCount;
      let applicableWidth = totalWidth - ((totalColumns - 1) * spaceBetweenColumn) - preOccupiedWidth
      let widthOFCell = applicableWidth / totalColumns;

      // Height
      let totalHeight = dataObject.dimensions.height;
      let totalRows  = 1 + dataObject.data.body.length
      let heightOfCell = totalHeight/ totalRows;

      if(this._DEBUG) {
        this.doc.rect(x, y, totalWidth, totalHeight);
      }


      // write the head
      let XPos = x;
      let YPos = y;
    
      let rows = [dataObject.data.head, ...dataObject.data.body];
      // Draw rows
      XPos = x; // Set to start to X;
      for(let b of rows) {
        let counter = 0;
        for(let cell of b){
          if(cell == null || cell == undefined) {
            cell = "";
          }
          let cellData = cell;
          let align = globalContentAlign;
          let valign = globalContentVerticalAlign;
          let cellPrevFontSize = null;
          let applicableCellWidth = widthOFCell;
          if(CUSTOM_WIDTH_SETTINGS) {
            if(widthsFromHeader[counter]) {
              applicableCellWidth = widthsFromHeader[counter];
            }
          }        
          if(typeof cell == "object") {
            let { 
              border, 
              value, 
              borderColor = null, 
              align:cellAlign = null, 
              valign:cellValign = null,
              fontSize: cellFontSize = null} = cell;

            // Border conf
            if(!borderColor) {
              borderColor = globalBorderColor;
            }
            if(border) {
              drawBorder(border, XPos, YPos, applicableCellWidth, heightOfCell, borderColor);
            }
            cellData = value;
            
            if(cellAlign){
                align = cellAlign
            }

            if(cellValign){
                valign = cellValign
            }

            if(cellFontSize) {
              cellPrevFontSize = this.doc.getFontSize();
              this.doc.setFontSize(cellFontSize);
            }
          }
          let { baseline, align:pdfAlign, modifiedXPos, modifiedYPos } = getTextAlignment(align, valign, XPos, YPos, applicableCellWidth, heightOfCell )
          this.doc.text(cellData.toString(), modifiedXPos, modifiedYPos, {
            maxWidth: applicableCellWidth,
            baseline: baseline,
            align: pdfAlign
          });
          XPos += spaceBetweenColumn + applicableCellWidth;
          if(cellPrevFontSize) {
            this.doc.setFontSize(cellPrevFontSize);
          }
          counter++;
        }        
        YPos += heightOfCell;
        XPos = x;  
      }
      
      if(prevFontSize) {
        this.doc.setFontSize(prevFontSize);
      }

    },

    /**
     * ColumnDivider
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'ColumnDivider': function(dataObject:any,  x:number, y:number)  {
      let columns = dataObject.data.columns;
      let columnGap = dataObject.attr.columnGap;
      let widthRatio = dataObject.attr.widthRatio;
      let totalWidth = this.getContainerWidth() - (columns - 1) * columnGap;
      let widthOfSingleColumn = totalWidth / columns;
      const getColumnWidth = (i:number) => {
        if(Array.isArray(widthRatio)) {
          let percentage = widthRatio[i - 1];
          return (percentage / 100) * totalWidth;
        }
        return widthOfSingleColumn;
      }

      
      let height = 0;
      
      for(let i = 1; i <= columns; i++) {
          let columnContents = dataObject.data.segments[i];
          let j = 0;
          let YPos = y;
          let colHeight = 0;
          
          //Clone the deep copy of 'this' and override the container width
          let that = copyBuilderInstance(this);
          that.getContainerWidth = () => getColumnWidth(i);
          that.getContainerStartWidth = () => {
            let startWidth = this.getContainerStartWidth();
            for(let j = 1; j<i; j++ ){
              startWidth+=  getColumnWidth(j);
            }
            return startWidth  + (i - 1) * columnGap;
          }
          
         

          while(j < columnContents.length ) {
            let content = columnContents[j];
            // Hopefully pre-check the element and provide the updated position
            // to content adder and we are using updated context
           let { preCheckedX, preCheckedY, preCheckedHeight, preCheckedWidth } = PreCheckerDict[content.type].bind(that)(content, x, YPos);

            // Pass the pre-checked cords
            let h = ContentAdderDict[content.type].bind(that)(content, preCheckedX, preCheckedY);
            let appliedHeight =  content.genericType == 'quantitative' ? preCheckedHeight : h;
            YPos += appliedHeight;
            colHeight += appliedHeight;
            if( j < columnContents.length) {
              YPos += this.SPACE_BETWEEN_CONTENT;
              colHeight += this.SPACE_BETWEEN_CONTENT;
            }  
            j++;
          }
         
          if(colHeight > height){
            height = colHeight;
          }
          if(this._DEBUG) {
            this.doc.setDrawColor("red");
            this.doc.rect(x , y,  getColumnWidth(i), height);
          }
         x = x + ( getColumnWidth(i) + columnGap);
      }

      return height;  
    },

    /**
     * Group
     * @param dataObject 
     * @param x 
     * @param y 
     */

    'Group': function(dataObject:any,  x:number, y:number)  {
      let items = dataObject.data;
      let height = 0;
      let yPos = y;
      let counter = 0;
      let totalCountOfItems = items.length;
      for(let content of items) {
        let { preCheckedX, preCheckedY, preCheckedHeight, preCheckedWidth } = PreCheckerDict[content.type].bind(this)(content, x, yPos);

        // Pass the pre-checked cords
        let h = ContentAdderDict[content.type].bind(this)(content, preCheckedX, preCheckedY);
        let appliedHeight =  content.genericType == 'quantitative' ? preCheckedHeight : h;
        height += appliedHeight
        yPos += appliedHeight
        if(counter+1 < totalCountOfItems) {
          height +=  this.SPACE_BETWEEN_CONTENT;
          yPos+= this.SPACE_BETWEEN_CONTENT;
        }   
        counter++;
      }
      return height     
    },
    
    /**
     * FeaturedBox
     * @param dataObject 
     * @param x 
     * @param y 
     */
    'FeaturedBox': function(dataObject:any,  x:number, y:number)  {
      let height = dataObject.dimensions.height;
      let width = dataObject.dimensions.width > this.getContainerWidth() ?  this.getContainerWidth() : dataObject.dimensions.width;
      console.log(x, width, 'expected next width', x + width);
      this.doc.setDrawColor(dataObject.attr.borderColor);
      this.doc.rect(x, y, width, height, 'S');
      let rows =   dataObject.data.rows;
      let totalItemLength = rows.length;
      let itemsCountWithHeight = 0;
      let heightAllocated = rows.reduce((accu:number, cv:any)=> {
        if(cv.colHeight){
          itemsCountWithHeight += 1;
          accu += cv.colHeight;
        }
        return accu;
      }, 0)

      let heightPerRow = (height - heightAllocated) / (totalItemLength - itemsCountWithHeight);
      let startY = y ;
      let [bottom = 0 , left = 0, right = 0, top= 0] = dataObject.attr.padding;
      for(let row of rows) {
        let affectedHeight = row.colHeight ? row.colHeight : heightPerRow;
        let fontSize = row.fontSize ?  row.fontSize : dataObject.attr.fontSize;
        let valign = row.valign ? row.valign : dataObject.attr.contentValign;
        let calign = row.align ? row.align : dataObject.attr.contentAlign;
        let { modifiedXPos, modifiedYPos, baseline,  align} = getTextAlignmentValues(valign, calign, startY, x, affectedHeight, width);

        let prevFillStyle = null;
        let prevTextColor = null;

        if(row.backgroundColor){
          prevFillStyle = this.doc.getFillColor();
          this.doc.setFillColor(row.backgroundColor);
          this.doc.rect(x, startY, width, affectedHeight, 'F'); 
        }
        if(row.color){
          prevTextColor = this.doc.getTextColor();
          this.doc.setTextColor(row.color);
        }
        this.doc.setFontSize(fontSize);
        this.doc.text(row.text.toString(), modifiedXPos + left, modifiedYPos, {
          baseline: baseline,
          align: align
        });
        startY+= affectedHeight;
        if(prevFillStyle) {
          this.doc.setFillColor(prevFillStyle);
        }
        if(prevTextColor) {
          this.doc.setTextColor(prevTextColor);
        }
       
      }

      return height;  
    },


     /**
     * WarningBox
     * @param dataObject 
     * @param x 
     * @param y 
     */
     'WarningBox': function(dataObject:any,  x:number, y:number)  {
      /**
       * TODO: This content dimension is stated below. If the total occupiable space 
       * is greater than below height/width then we can use that excess space for
       * alignment. 
       */
      const Box_Width = 75;
      const Box_Height = 45;
      const Box_Main_FontSize = 16;
      const Box_Sub_FontSize = 10;
     
      this.doc.setDrawColor(dataObject.attr.lineColor);
      this.doc.rect(x, y, Box_Width, Box_Height)

      this.doc.setFontSize(Box_Main_FontSize);
      this.doc.text(dataObject.data.value.toString(), x + Box_Width/2, y + Box_Height/2, {
        align: 'center',
        baseline: 'middle',
        maxWidth: Box_Width
      });  


      this.doc.setFontSize(Box_Sub_FontSize);
      this.doc.text(dataObject.data.unit,  x + Box_Width - 15, y + Box_Height/2, {
        align: 'center',
        baseline: 'middle',
        maxWidth: Box_Width
      });
      if(this.doc.getTextWidth(dataObject.data.adviceType) > Box_Width - 10){
        this.doc.setFontSize(Box_Sub_FontSize-2);
      }
      this.doc.text(dataObject.data.adviceType, x + Box_Width - 10, y + Box_Height -10, {
        align: 'right',
        baseline: 'middle',
        maxWidth: Box_Width - 10
      });

      this.doc.setFontSize(Box_Sub_FontSize);


      let adviceTextWidth = this.doc.getTextWidth(dataObject.data.adviceText);
      let availableContainerWidth =  this.getContainerWidth() - Box_Width - 10;
      let lines = Math.round(adviceTextWidth/availableContainerWidth);
      let yPos =  y + Box_Height/2
      if(lines > 1) {
        yPos = yPos - lines * 4.5;
      } 

      this.doc.text(dataObject.data.adviceText, x + Box_Width + 10, yPos, {
        align: 'left',
        baseline: 'middle',
        maxWidth: availableContainerWidth
      });
     
      this.doc.setFillColor(dataObject.attr.warningColor);     
      this.doc.lines([  
      [0, -20],
      [-8, 20],
      [0, 0],
      ], x + Box_Width, y + Box_Height, [1, 1], 'F', true);

    },

     /**
     * AdviceBox
     * @param dataObject 
     * @param x 
     * @param y 
     */
     'AdviceBox': function(dataObject:any,  x:number, y:number)  {
      /**
       * TODO: This content dimension is stated below. If the total occupiable space 
       * is greater than below height/width then we can use that excess space for
       * alignment. 
       */
      console.log(dataObject)
      const Box_Width = 75;
      const Box_Height = 45;
      const Box_Main_FontSize = 16;
      const Box_Sub_FontSize = 10;
     
      this.doc.setDrawColor(dataObject.attr.lineColor);
      this.doc.rect(x, y, Box_Width, Box_Height)

      this.doc.setFontSize(Box_Main_FontSize);
      this.doc.text(dataObject.data.value.toString(), x + Box_Width/2, y + Box_Height/2, {
        align: 'center',
        baseline: 'middle',
        maxWidth: Box_Width
      });  


      this.doc.setFontSize(Box_Sub_FontSize);
      this.doc.text(dataObject.data.unit,  x + Box_Width - 15, y + Box_Height/2, {
        align: 'center',
        baseline: 'middle',
        maxWidth: Box_Width
      });
      if(this.doc.getTextWidth(dataObject.data.adviceType) > Box_Width - 10){
        this.doc.setFontSize(Box_Sub_FontSize-2);
      }
      this.doc.text(dataObject.data.adviceType, x + Box_Width - 10, y + Box_Height -10, {
        align: 'right',
        baseline: 'middle',
        maxWidth: Box_Width - 10
      });

      this.doc.setFontSize(Box_Sub_FontSize); 
      this.doc.setFillColor(dataObject.attr.warningColor);     
      this.doc.lines([  
      [0, -20],
      [-8, 20],
      [0, 0],
      ], x + Box_Width, y + Box_Height, [1, 1], 'F', true);

    }
  };

  export default ContentAdderDict;